import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";

export const StockQuantity = () => {
    document.title = "Sənədlərdə anbar qalığı";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Ümumi anlayışlar", value: "/common" },
        { name: "Sənədlərdə anbar qalığı", value: "/common/stockquantity", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Sənədlərdə anbar qalığı</h2>
                    <p>
                        Sənədlərin içində göstərilən anbar qalığı, sənədin yarandığı tarixdəki ( andakı ) anbar qalığıdır.
                        <br />
                        <b>Qeyd: </b>sənəd yaradıldığı tarixdən ( andan ) öncəki qalıqdır.
                    </p>
                    <img src="/images/common/stockquantity.gif" alt="Sənədlərdə anbar qalığı" />
                </article>
            </div>
        </div>
    );
};
